import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import ReactTable from "react-table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen } from "@fortawesome/free-solid-svg-icons";
import filterCaseInsensitive from "helpers/react-table-case-insensitive";
import {
  openCustomModal,
  closeCustomModal
} from "views/lib/components/modals";
import {
  tariffGetList,
  tariffAdd,
  tariffAddImage,
} from "actions/chargers/tariff/actions";

import EditModal from "./edit-modal";
import ImageModal from "./image-modal";

class Tariff extends React.Component {
  constructor(props) {
    super(props);

    this.modalEdit = this.modalEdit.bind(this);
    this.modalLogo = this.modalLogo.bind(this);

    this.props.tariffGetList();
  }

  getColumns = () => [
    {
      id: "tariff-id",
      Header: "#",
      accessor: "id",
    },
    {
      Header: "Active",
      accessor: "active",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => (
        <div className={original.active ? "text-success" : "text-danger"}>
          {original.active ? "Active" : "Inactive"}
        </div>
      )
    },
    {
      Header: "Country",
      accessor: "country",
    },
    {
      id: "order",
      Header: "Order",
      accessor: "order",
      headerClassName: "text-center",
      className: "text-center"
    },
    {
      id: "price",
      Header: "Price",
      accessor: "price",
      headerClassName: "text-center",
      className: "text-center"
    },
    {
      id: "rate",
      Header: "Rate",
      accessor: "rate",
      headerClassName: "text-center",
      className: "text-center"
    },
    {
      id: "duration",
      Header: "Duration",
      accessor: "duration",
      headerClassName: "text-center",
      className: "text-center"
    },
    {
      Header: "Station Type",
      accessor: "stationType",
    },
    {
      Header: "Type",
      accessor: "type",
    },
    {
      id: "actions",
      Header: "Actions",
      Cell: ({ original }) => (
        <div className="d-flex justify-content-around">
          <button
            className="btn btn-sm btn-primary"
            onClick={() => this.modalEdit(original)}
          >
            <FontAwesomeIcon icon={faPen}/>
          </button>
          {/* <button
            className="btn btn-sm btn-warning"
            onClick={() => this.modalLogo(original.id, original.name)}
          >
            <FontAwesomeIcon icon={faFileImage}/>
          </button> */}
        </div>
      ),
      headerClassName: "text-center",
      className: "text-center"
    }
  ];

  onSubmit = (data) => {
    this.props.tariffAdd(data, (response) => {
      if (response.id && data.imageFile && data.imageFile.fileName) {
        this.props.tariffAddImage(response.id, data.imageFile, () => {
        });
      }
    });
  };

  modalEdit = (tariff = false) => {
    const modalObj = {
      modalSettings: {
        size: "md"
      },
      header: tariff ? `Edit Tariff "${tariff.code}"` : "Create New Tariff",
      children: (
        <EditModal
          tariff={tariff}
          onCancel={() => this.props.closeCustomModal(modalObj)}
          onSubmit={(data) => {
            this.onSubmit(data);
            this.props.closeCustomModal(modalObj);
          }}
        />
      ),
      handleClose: () => this.props.closeCustomModal(modalObj)
    };
    this.props.openCustomModal(modalObj);
  };

  modalLogo = (tariffId, tariffName) => {
    const modalObj = {
      modalSettings: {
        size: "sm"
      },
      header: "Change Logo",
      children: (
        <ImageModal
          tariffId={tariffId}
          tariffName={tariffName}
          onCancel={() => this.props.closeCustomModal(modalObj)}
          onSubmit={() => {
            this.props.closeCustomModal(modalObj);
          }}
        />
      ),
      handleClose: () => this.props.closeCustomModal(modalObj)
    };
    this.props.openCustomModal(modalObj);
  };

  render() {
    const {
      tariffList,
    } = this.props;

    return (
      <div className="w-100 p-2">
        <div className="filters">
          <div className="d-flex justify-content-between filters">
            <h3>Chargers tariffs</h3>
            <div>
              <button
                className="btn btn-sm btn-success"
                onClick={() => this.modalEdit()}
              >
                Create New Tariff
              </button>
            </div>
          </div>
        </div>

        <ReactTable
          data={tariffList}
          headerClassName="table-header"
          columns={this.getColumns()}
          pageSizeOptions={[10, 20, 50, 100]}
          resizable
          className="-striped -highlight"
          loading={false}
          filterable={false}
          defaultFilterMethod={filterCaseInsensitive}
          getNoDataProps={() => ({
            style: {
              zIndex: 0
            }
          })}
          style={{
            height: "calc(100vh - 110px)"
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  tariffList: state.chargerTariff.tariffList,
});

const mapStateToDispatch = dispatch => ({
  openCustomModal: bindActionCreators(openCustomModal, dispatch),
  closeCustomModal: bindActionCreators(closeCustomModal, dispatch),

  tariffGetList: bindActionCreators(tariffGetList, dispatch),
  tariffAdd: bindActionCreators(tariffAdd, dispatch),
  tariffAddImage: bindActionCreators(tariffAddImage, dispatch),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(Tariff);



// WEBPACK FOOTER //
// ./src/views/pages/chargers/tariff/list.js